/**
 * @classdesc URL解析系のユーティリティ クラス
 */
export default class UrlUtils {
    /**
     * Query 取得
     */
    static getQuery() {
        const queryStr = window.location.search.slice(1); // 文頭?を除外
        const queries = {};

        // クエリがない場合は空のオブジェクトを返す
        if (!queryStr) return queries;

        // クエリ文字列を & で分割して処理
        queryStr.split("&").forEach(function (queryStr) {
            // = で分割してkey,valueをオブジェクトに格納
            var queryArr = queryStr.split("=");
            queries[queryArr[0]] = queryArr[1];
        });

        return queries;
    }

    /**
     * srcに付加したURLパラメータを取得
     * src="test.js?○○
     * @retun {key:string}
     */
    static getSrcParam() {
        const scripts = document.getElementsByTagName("script");
        const src = scripts[scripts.length - 1].src;
        const query = src.substring(src.indexOf("?") + 1);
        const parameters = query.split("&");

        const result = {};
        for (var i = 0; i < parameters.length; i++) {
            const element = parameters[i].split("=");
            const paramName = decodeURIComponent(element[0]);
            const paramValue = decodeURIComponent(element[1]);
            result[paramName] = paramValue;
        }

        return result;
    }
}
